module.exports = __webpack_public_path__ + "img/02_no.f7b7f225.svg";